import {Container, Grid, Paper, TableBody, TableHead} from "@mui/material";
import {
    StyledButtonContainer, StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import * as DataProvider from "../../logic/DataProvider";
import dayjs from "dayjs";
import {GetEnumValueName} from "../../logic/EnumHelper";
import {
    GetCryptoAmountExecutedAsSting,
    GetCryptoAmountRequestedAsSting, GetExecutedPricesSting,
    GetRequestedPricesSting
} from "../../logic/OrderVolumeHelper";
import {useNavigate} from "react-router-dom";


const OrdersPage = () => {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.orders) {
                let entities = bundle.orders;
                setOrders(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleRequestNew = () => {
        navigate(`request`);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleRequestNew}>
                        New
                    </StyledButtonOrange>
                </Grid>
            </StyledButtonContainer>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={9}>Created Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Expiration Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Action</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Type</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Status</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Crypto Amount Requested</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Requested Price</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Crypto Amount Executed</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Executed Price</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {orders && orders.map((order) => (
                            <StyledTableBodyRow key={order.id}>
                                <StyledTableCell>{dayjs(order.createdDate).toDate().toDateString()}</StyledTableCell>
                                <StyledTableCell>{dayjs(order.expirationDate).toDate().toDateString()}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('orderAction', order.action)}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('orderType', order.type)}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('orderStatus', order.status)}</StyledTableCell>
                                <StyledTableCell>{GetCryptoAmountRequestedAsSting(order)}</StyledTableCell>
                                <StyledTableCell>{GetRequestedPricesSting(order)}</StyledTableCell>
                                <StyledTableCell>{GetCryptoAmountExecutedAsSting(order)}</StyledTableCell>
                                <StyledTableCell>{GetExecutedPricesSting(order)}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default OrdersPage;